export default {
	back_to_top: '回到顶部',
	banner_btn: {
		buy_now: '现在购买',
		learn_more: '了解更多',
	},
	banner_list: [
		{
			title: '安全稳定 · 卓越性价比 · 全球网络的物理服务器',
			subtitle: '独立物理服务器',
			desc: '物理服务器以独享硬件、高性能可定制、强隔离安全性，为多种业务场景提供企业级算力支持<br />助力业务稳健运行与持续增长',
		},
		{
			title: 'NVMe 极速 I/O · 新一代 高性能 VPS',
			subtitle: 'NVMe云服务器',
			desc: '基于最新一代INTEL志强处理器，您无需为硬件的购买和维护投入精力<br />即购买、即开通、即使用，快部署应用',
		},
	],
	data_center: {
		desc: '覆盖亚洲、北美、欧洲等核心数据中心与多家 Tier 1 级国际运营商直连，TB 级中国运营商 3C 专线资源，支持 CN2/GIA。',
		list: [
			{ key: 'hk', name: '香港' },
			{ key: 'us', name: '美国' },
			{ key: 'jp', name: '日本' },
			{ key: 'kr', name: '韩国' },
			{ key: 'my', name: '马来西亚' },
			{ key: 'sg', name: '新加坡' },
			{ key: 'au', name: '澳大利亚' },
		],
		title: '数据中心的位置',
	},
	product: {
		desc: '基于新一代云计算架构打造的高性价比 VPS，带来更快、更稳、更灵活的性能体验 \n 让您的项目全面加速',
		specialties: [
			{ title: '可视化管理平台', desc: '为您提供了智能控制中心对云服务器进行管理。您可对云服务器进行开机、关机、重置密码、重装系统等操作' },
			{ title: '更高的速度', desc: '纯U.2 NVMe架构单盘容量高达8000G，IOPS/磁盘高达641,800，吞吐量/磁盘高达3200MBps，时延低至11（µs）' },
			{ title: '全球多网络线路', desc: '网络接入中国电信、移动、联通，PCCW、香港宽频、NTT、Cogent 、Leve3、Lumen 等，提供用户自定义VPC组网安全隔离' },
		],
		title: 'NVMe 极速 I/O · 新一代 高性能 VPS ',
	},
	products: {
		desc: '我们提供多种服务器产品，包括VPS主机和服务器租用，满足您的不同需求',
		list: [
			{ title: 'VPS主机', desc: '高速稳定高弹性的计算服务，采用NVMe架构轻松云端获取和启用，实现您的计算' },
			{ title: '服务器租用', desc: '服务器租用采用高规格硬件确保稳定性和高性能，平台全自动化，一键重启、重装等助力核心业务飞速成长。' },
		],
		title: '多种服务器产品',
	},
	stats: {
		data_centers: '数据中心',
		support: '客户支持',
		uptime: '在线率',
		virtualization: '虚拟化',
	},
	testimonials: {
		desc: '我们用心收集每一位用户提交的意见或建议。',
		title: '我们的客户评价',
	},
	testimonials_list: [
		{ quote: '弹性云自主配置资源，不在浪费多余的钱，而且还有机龄计划，越用越开心。', name: 'Jerry Liu' },
		{ quote: '对资源自动监控，控制滥用用户，保障网络连接不卡顿，硬盘不变石头，值得推荐。', name: '屌丝' },
		{ quote: '云服务器拥有有强大的自定义面板，在线操作，方便快捷，一触即达；价格实惠，性能优越，是云服务器的不错选择。', name: '梦い' },
	],
	why: {
		desc: '我们 2012 年开始涉及虚拟主机，2014 年涉及云服务器，于 2019 年成立新品牌，全线云服务器产品均采用成熟的 KVM 虚拟化技术，配合自主研发简体中文易操作控制面板，能为您提供成熟的云服务器产品，高可用的自主管理。',
		list: [
			{
				title: '担心资源不够用？',
				desc: '业务刚起步，服务商就说IP不够了；旺季流量涨了，带宽跟不上；被迫迁移服务器，损失惨重',
				solution: '解决方案：百万IP+TB级带宽，站群IP80美元/月起',
				case: '从1台到1000台，我们都能接住',
			},
			{
				title: '担心出问题没人管？',
				desc: '半夜服务器挂了，客服让你发英文邮件；技术问题说不清，沟通成本太高；找不到人，只能干着急',
				solution: '解决方案：7×24中文客服，15分钟响应紧急故障',
				case: '母语沟通，零障碍服务',
			},
			{
				title: '担心技术门槛高？',
				desc: '买了服务器不会配置环境；装个WordPress都要折腾半天；想专心做业务，不想学Linux命令',
				solution: '解决方案：一键部署，3分钟上线应用',
				case: '对比：传统几小时→我们3-5分钟',
			},
		],
		title: '为什么选择我们',
	},
}
